import _mergeWith from "lodash/mergeWith"
import _isArray from "lodash/isArray"
import _merge from "lodash/merge"
import _set from "lodash/set"
import _get from "lodash/get"
import _cloneDeep from "lodash/cloneDeep"

export default (one, two, path) => {
    //console.log(one, two, path)
    const one_ = _cloneDeep(one)
    return(
        path ? (
            _set(one_, path, _isArray(two) ? two : _merge(_get(one_, path), two))
        ) : (
            _mergeWith(one_, two, function (objValue, srcValue) {
                if (_isArray(objValue)) {
                    return srcValue
                }
            })
        )
    )
}